<template>
  <SACModal
    modalClass="comfort-credit-action-modal"
    :cardClass="`ccam-${actionModalView}`"
    :show="showActionModal"
    :close="close"
  >
    <template
      v-if="actionModalView === 'loyalty'"
      #content
    >
      <ChangeLoyaltyProgramName
        :close="close"
        :partnerSettings="partnerSettings"
        :update="update"
      />
    </template>
    <template
      v-else-if="actionModalView === 'preferred-plan'"
      #content
    >
      <PreferredPlan
        :close="close"
        :partnerSettings="partnerSettings"
        :update="update"
      />
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';
import ChangeLoyaltyProgramName from './actionModal/ChangeLoyaltyProgramName.vue';
import PreferredPlan from '../providerPlan/actionModal/PreferredPlan.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    ChangeLoyaltyProgramName,
    PreferredPlan,
  },
  props: {
    actionModalView: String,
    showActionModal: Boolean,
    close: Function,
    partnerSettings: Object,
    update: Function,
  },
};
</script>

<style lang="scss">

.comfort-credit-action-modal {
  .ccam-preferred-plan {
    width: 640px;
    height: auto;
  }
  .ccam-preferred-plan {
    width: 640px;
    height: auto;
  }
  .ccam-loyalty {
    width: 400px;
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    .ac-header-container {
        padding: 29px 24px 19px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid $NBLUE10;

        .ac-header {
          font-size: 1.25rem;
          font-weight: 500;
        }

        .ac-close-button {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background-color: $NBLUE10;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background-color: $NBLUE20;
          }

          .ac-close {
            width: 10px;
            height: 10px;
          }
        }
      }
      .ac-body-container {
        flex: 1;
        padding: 31px 24px 26px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ac-input-container {
          width: 100%;
          margin-right: 12px;

          &:not(:last-child) {
            margin-bottom: 18px;
          }

          .ac-input-header {
            font-size: 0.875rem;
            font-weight: 500;
            margin-bottom: 3px;
          }
      }

        .ac-close-container {
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;

          .ac-close-btn {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 2px solid $NAVY100;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 50%;
              object-fit: contain;
            }
          }
        }

        .ac-info-logo {
          width: 25px;
          object-fit: contain;
          margin-bottom: 4px;
        }

        .ac-body {
          font-size: 1.25em;
          color: $N90;
          text-align: center;
        }

        .ac-button {
          padding: 6px 9px 5px;
          font-size: 0.75em;
          font-weight: 500;
          color: $N90;
          background-color: #CAD7FF;
          border-radius: 3px;
          margin-top: 36px;
          line-height: 1;

          &:first-child {
            margin-right: 10px;
          }

          &.red {
            background-color: $PUNCH !important;
            color: $WHITE !important;
          }
        }
      }
      .secondary-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: $WHITE;
        border: solid 4px $NBLUE100;
        border-radius: 8px;
        color: $NBLUE100;
        padding: 12px 18px;
        font-weight: 600;

        &.blue {
          background-color: $NBLUE100;
          opacity: 0.3;
          color: $NBLUE100;
        }
      }
      .primary-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        border: solid 4px $NBLUE100;
        background-color: $NBLUE100;
        border-radius: 8px;
        color: $WHITE;
        padding: 12px 18px;
        font-weight: 600;

        &.active {
          background-color: $NBLUE100;
        }

        &.inactive {
          opacity: 0.3;
        }
      }
  }
}
</style>
